import { useEffect, useRef, useState } from 'react';
import { useFormik } from 'formik';
import { useStore } from 'src/stores';
import { useTimer } from 'src/core/hooks';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

/**
 * <useTryZynProps /> props
 */
const useTryZynProps = () => {
  const {
    formStore: {
      loading,
      sendPhone,
      sendOtp,
      sendCall,
      popupType,
      setPopupType,
      popup,
      setPopup,
      subscription,
      setSubscription,
      locale,
      setErrorOtp,
      errorOtp
    }
  } = useStore();

  const [phone, setPhone] = useState('');

  const [errorPhone, setErrorPhone] = useState('');
  const [posId, setPosid] = useState('');
  const [params, setParams] = useState({});
  const [isAgeGate, setIsAgeGate] = useState(false);

  const [isTouched, setIsTouched] = useState(false);

  const { time, startTimer, resetTimer, stopTimer } = useTimer(60);
  const [code, setCode] = useState('');
  const [callMe, setCallMe] = useState(false);
  const [calling, setCalling] = useState(false);

  const phoneRegex = /^\+?3?8?((034|039|050|063|066|067|068|073|091|092|093|094|095|096|097|098|099|077|075)\d{7})$/;

  const windowDataLayerPush = (payload: any) => {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push(payload);
  };

  const pushDLonVisible = (event: string) => {
    if (!window?.dataLayer.find((el: any) => el.event === event))
      windowDataLayerPush({
        event
      });
  };

  const handleScroll = () => {
    document.getElementById('form').scrollIntoView();

    windowDataLayerPush({
      event: 'try_zyn_click_want'
    });
  };

  const onChange = (event: any) => {
    if (!window?.dataLayer.find((el: any) => el.event === 'try_zyn_form_start'))
      windowDataLayerPush({
        event: 'try_zyn_form_start'
      });
    setPhone(event.target.value);
    setErrorPhone('');
  };

  const handleClick = () => {
    if (popupType === 'form') {
      validateForm(phone);
    } else if (popupType === 'otp') {
      onCheckCode();
    } else {
      setPopup(false);
      setCallMe(true);
    }
  };

  const handleClose = () => {
    setPopup(false);
    setErrorPhone('');
  };

  const validateForm = async (phone: string) => {
    const isValid = new RegExp(phoneRegex).test(phone.replaceAll(' ', ''));
    let isPushed = false;

    if (isValid && phone.replaceAll(' ', '').length === 13) {
      setErrorPhone('');
    } else {
      setErrorPhone(
        'Неправильний номер. Перевір і спробуй ще раз, будь ласка.'
      );

      windowDataLayerPush({ event: 'try_zyn_form_error' });
      isPushed = true;
      return;
    }

    if (!errorPhone) {
      const token = '';
      sendPhone(params, phone, resetTimer, stopTimer);
      setCode('');
      setCallMe(false);
      setCalling(false);

      windowDataLayerPush({ event: 'try_zyn_show_otp_input' });
    }
  };

  const onCheckOtp = (code: any) => {
    setCode(code);
  };

  const onCheckCode = () => {
    sendOtp(code, params, phone, subscription);
  };

  const onKeyDown = (event: any) => {
    setErrorOtp(false);
    if (event.key !== 'Enter' || code.length !== 4) return;
    onCheckCode();
  };

  const onCallMe = () => {
    setErrorOtp(false);
    setCode('');
    sendCall(params, phone);
    setCallMe(true);
    setCalling(true);
  };

  const form = useFormik({
    initialValues: {
      otp: ''
    },
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: onCheckCode
  });

  const { values, errors, setFieldValue } = form;

  useEffect(() => {
    let params = new URLSearchParams(document.location.search);
    let pos = params.get('POS_ID');
    let chain = params.get('chain');
    let app = params.get('app');
    let scenario = params.get('scenario');
    let type = params.get('type');
    let reg_channels_id = params.get('reg_channels_id');

    setPosid(pos);
    setParams({ pos, chain, app, scenario, type, reg_channels_id });
    if (!window?.dataLayer.find((el: any) => el.event === 'try_zyn_visit'))
      windowDataLayerPush({
        event: 'try_zyn_visit'
      });
  }, []);

  useEffect(() => {
    if (popupType === 'otp') {
      setFieldValue('otp', values.otp);
      setCode(values.otp);
    }
  }, [values]);

  useEffect(() => {
    if (popupType === 'otp') {
      if (time === 0) {
        // stopTimer();
        setCallMe(true);
      }
    }
  }, [time]);

  useEffect(() => {
    if (popupType === 'otp') {
      setCode('');
    }
  }, [popupType]);

  return {
    locale,
    phone,
    loading,
    popup,
    popupType,
    setPhone,
    errorPhone,
    setErrorPhone,
    sendPhone,
    setPopupType,
    setPopup,
    handleClose,
    time,
    setSubscription,
    errorOtp,
    code,
    onKeyDown,
    onCheckOtp,
    errors,
    handleClick,
    onCallMe,
    callMe,
    calling,
    subscription,
    isTouched,
    onChange,
    setIsTouched,
    validateForm,
    handleScroll,
    pushDLonVisible,
    isAgeGate,
    setIsAgeGate
  };
};

export { useTryZynProps };
